export const getHiddenResources = ({ isXXLWidth, workers, equipment }) => {
  if (!isXXLWidth) return workers.length + equipment.length - 3;
  const hiddenWorkers = workers.length > 3 ? workers.length - 3 : 0;
  const hiddenEquipment = equipment.length > 3 ? equipment.length - 3 : 0;
  return hiddenWorkers + hiddenEquipment;
};
